import '../css/index.scss';
import APlayer from './player';

/* global APLAYER_VERSION */
console.log(`${'\n'} %c APlayer-Vite v${APLAYER_VERSION} %c https://github.com/o0w0b/aplayer-vite ${'\n'}`, 'color: #fadfa3; background: #030307; padding:5px 0;', 'background: #fadfa3; padding:5px 0;');

export default APlayer;
